(function(){
	'use strict';
	angular.module('app.setup')
		.service('manageEmailAlertsService', manageEmailAlertsService);

	manageEmailAlertsService.$inject = ['$http', 'hostUrl'];

	function manageEmailAlertsService($http, hostUrl) {
		return {
			updateSubscriptionForUsers: updateSubscriptionForUsers,
			updateSubscriptionForRoles: updateSubscriptionForRoles,
			getUnsubscribed: getUnsubscribed,
			updateSubscriptionForUser: updateSubscriptionForUser,
			updateSubscriptionForRole: updateSubscriptionForRole
		};

		function updateSubscriptionForUsers(doDelete, alertType, userList, siteId) {
			var url = hostUrl + '2/factndx/' + (siteId || globalConfig.factory.id) + '/AlertSubscription/Type/' + alertType + '/Users/' + userList;
			if (doDelete) url += '?delete=true';
			return $http.post(url)
				.then(updateSubscriptionForUsersComplete)
				.catch(updateSubscriptionForUsersFailed);

			function updateSubscriptionForUsersComplete(response) {
				return response;
			}

			function updateSubscriptionForUsersFailed(error) {
				return error;
			}
		}

		function updateSubscriptionForUser(doDelete, alertType, userNdx, conditions, siteId) {
			var url = hostUrl + '2/factndx/' + (siteId || globalConfig.factory.id) + '/AlertSubscription/Type/' + alertType + '/User/' + userNdx;
			var qParams = '';
			if (doDelete) qParams += '?delete=true';
			if (conditions && conditions.length) {
				if (qParams.length) {
					qParams += '&conditions=' + conditions;
				} else {
					qParams += '?conditions=' + conditions;
				}
			}

			return $http.post(url + qParams)
				.then(updateSubscriptionForUserComplete)
				.catch(updateSubscriptionForUserFailed);

			function updateSubscriptionForUserComplete(response) {
				return response;
			}

			function updateSubscriptionForUserFailed(error) {
				return error;
			}
		}

		function updateSubscriptionForRoles(doDelete, alertType, roleList, siteId) {
			var url = hostUrl + '2/factndx/' + (siteId || globalConfig.factory.id) + '/AlertSubscription/Type/' + alertType + '/Roles/' + roleList;
			if (doDelete) url += '?delete=true';
			return $http.post(url)
				.then(updateSubscriptionForRolesComplete)
				.catch(updateSubscriptionForRolesFailed);

			function updateSubscriptionForRolesComplete(response) {
				return response;
			}

			function updateSubscriptionForRolesFailed(error) {
				return error;
			}
		}

		function updateSubscriptionForRole(alertType, role, conditions, siteId) {
			var url = hostUrl + '2/factndx/' + (siteId || globalConfig.factory.id) + '/AlertSubscription/Type/' + alertType + '/Role/' + role;
			var qParams = '';
			if (conditions && conditions.length) {
				qParams += '?conditions=' + conditions;
			}

			return $http.post(url + qParams)
				.then(updateSubscriptionForRoleComplete)
				.catch(updateSubscriptionForRoleFailed);

			function updateSubscriptionForRoleComplete(response) {
				return response;
			}

			function updateSubscriptionForRoleFailed(error) {
				return error;
			}
		}

		function getUnsubscribed(alertType, viewType, siteId) {
			var url = hostUrl + '2/factndx/' + (siteId || globalConfig.factory.id) + '/AlertSubscription/Type/' + alertType + '/Unsubscribed' + viewType;
			return $http.get(url)
				.then(getUnsubscribedComplete)
				.catch(getUnsubscribedFailed);

			function getUnsubscribedComplete(response) {
				return response.data;
			}

			function getUnsubscribedFailed(error) {
				return [];
			}
		}
	};
})();
